const music = [
    {
        alias: "the-intro",
        navigation: [
            {
                link: "/music/the-intro",
                title: "Home",
                type: "internal",
            },
            {
                link: "/music/about-cbc-music-s-the-intro-1.6219967",
                title: "About",
                type: "internal",
            },
        ],
    },
];

export default music;
